import { render, staticRenderFns } from "./BarcodeTable.vue?vue&type=template&id=6b7133f4&scoped=true&"
import script from "./BarcodeTable.vue?vue&type=script&lang=js&"
export * from "./BarcodeTable.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeTable.vue?vue&type=style&index=0&id=6b7133f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7133f4",
  null
  
)

export default component.exports